import API from "../../../global/api";

import jsPDF from "jspdf";
import logo from "../../../Images/logo.png";
import { isEmpty, isNull, sumBy } from "lodash";
import "jspdf-barcode";
import Code128Generator from "code-128-encoder";
const font =
  "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";
const callAddFont = function () {
  this.addFileToVFS("code128-normal.ttf", font);
  this.addFont("code128-normal.ttf", "code128", "normal");
};
export const requestAddShipment = () => {
  return {
    type: "REQUEST_ADD_SHIPMENT",
  };
};
export const successAddShipment = (data) => {
  getWayBill(data);
  (data.shipment_type == "Pack" && data.invoice_type == 1) && invoice(data);
  return {
    type: "SUCCESS_ADD_SHIPMENT",
    payload: data,
  };
};
export const errorAddShipment = () => {
  return {
    type: "ERROR_ADD_SHIPMENT",
  };
};
export const addShipment = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestAddShipment());
    API.post(`/shipment`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(successAddShipment(data1.shipment_data[0]));
        // dispatch(getWayBill(data1))

        //  res.data.shipment_data[0].shipment_type=="Package"&&dispatch(invoice((res.data.shipment_data[0])))

        handleVisible(res.data.message);
      })
      .catch((error) => {
        dispatch(errorAddShipment());
        handleDangerVisible("Somthing Went Wrong");
        //  handleDangerVisible(error.response.data.message);
      });
  };
};

export const requestGetShipment = () => {
  return {
    type: "REQUEST_GET_SHIPMENT",
  };
};
export const successGetShipment = (data) => {
  return {
    type: "SUCCESS_GET_SHIPMENT",
    payload: data,
  };
};
export const errorGetShipment = () => {
  return {
    type: "ERROR_GET_SHIPMENT",
  };
};
export const getShipment = () => {
  return (dispatch) => {
    dispatch(requestGetShipment());
    // API.get(`/shipment?page=${pageno}&size=10`)
    API.get(`/shipment`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipment(getData));
      })
      .catch((error) => {
        dispatch(errorGetShipment());
      });
  };
};
export const getShipmentPagination = (pageno) => {
  return (dispatch) => {
    dispatch(requestGetShipment());
    API.get(`/shipment?page=${pageno}&size=10`)
      // API.get(`/shipment`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipment(getData));
      })
      .catch((error) => {
        dispatch(errorGetShipment());
      });
  };
};
export const getShipmentPaginationWithDates = (pageno,startDate,endDate) => {
  return (dispatch) => {
    dispatch(requestGetShipment());
    API.post(`/shipment/get_shipment_with_dates?page=${pageno}&size=100`,{startedDate:startDate,endDate:endDate})
      // API.get(`/shipment`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipment(getData));
      })
      .catch((error) => {
        dispatch(errorGetShipment());
      });
  };
};
export const DeleteRequestShipment = () => {
  return {
    type: "DELETE_REQUEST_SHIPMENT",
  };
};
export const DeleteSuccessShipment = (user_id) => {
  return {
    type: "DELETE_SUCCESS_SHIPMENT",
    user_id: user_id,
  };
};
export const DeleteErrorShipment = () => {
  return {
    type: "DELETE_ERROR_SHIPMENT",
  };
};
export const deleteShipment = (vendorId) => {
  return (dispatch) => {
    dispatch(DeleteRequestShipment());
    API.delete(`/shipment/${vendorId}`)
      .then((res) => {
        // dispatch(getShipmentData());
        dispatch(DeleteSuccessShipment(vendorId));
      })
      .catch((error) => {
        dispatch(DeleteErrorShipment());
      });
  };
};
export const UpdateRequestShipment = () => {
  return {
    type: "UPDATE_REQUEST_SHIPMENT",
  };
};
export const UpdateSuccessShipment = (data) => {
  return {
    type: "UPDATE_SUCCESS_SHIPMENT",
    payload: data,
  };
};

export const UpdateErrorShipment = () => {
  return {
    type: "UPDATE_ERROR_SHIPMENT",
  };
};

export const updateShipment = (data, id) => {
  return (dispatch) => {
    dispatch(UpdateRequestShipment());
    API.put(
      `/shipment/${id}`,
      {
        data
        // name: data.name,
        // company: data.companyName,
        // // country_id:data.countryId,
        // address: data.companyAddress,
        // address_2: data.companyAddress2,
        // address_3: data.companyAddress3,
        // postal_code: data.postalCode,
        // city: data.city,
        // state: data.state,
        // email: data.email,
        // phone: data.phone,
        // status: data.shipment_status.status,
      },
      {}
    )
      .then((res) => {
        dispatch(getShipment());
        dispatch(UpdateSuccessShipment([data]));
      })
      .catch((error) => dispatch(UpdateErrorShipment()));
  };
};
export const nextSteps = () => {
  return {
    type: "NEXT_STEPS",
    //  payload: data
  };
};
export const backSteps = () => {
  return {
    type: "BACK_STEPS",
    //  payload: data
  };
};
export const startSteps = () => {
  return {
    type: "START_STEPS",
    // payload: data
  };
};
export const setAddPackagingDetail = (data) => {
  return {
    type: "SET_ADD_PACKING_DETAIL",
    payload: data,
  };
};
export const handleAddInputPackagingDetail = () => {
  return {
    type: "SET_ADD_INPUT_PACKING_DETAIL",
    // payload: data
  };
};
export const handleAddInputPackagingDetailWithData = (data) => {
  return {
    type: "SET_ADD_INPUT_PACKING_DETAIL_WITH_DATA",
    payload: data,
  };
};
export const handleRemoveInputPackagingDetail = (i) => {
  return {
    type: "SET_REMOVE_INPUT_PACKING_DETAIL",
    payload: i,
  };
};

export const getWayBill = (ShipmentData) => {
  // return ()=>
  // const ShipmentData=Shipment.shipment_data[0]
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "landscape"; // portrait or landscape
  const marginLeft = 20;
  const marginTop = 30;
  const doc = new jsPDF(orientation, unit, size);
  doc.addImage(logo, "PNG", 35, 0, 200, 40);

  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  doc.text(`WAYBILL DOC`, marginLeft, 55, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  // doc.text(
  //   `Not to be attached to package - Hand to Courier`,
  //   marginLeft,
  //   65,
  //   0,
  //   0
  // );
  doc.text(`${ShipmentData.shipment_date}`, marginLeft, 75, 0, 0);
  doc.setFontSize(24);
  doc.setFont(undefined, "bold");
  doc.text(`WPS`, 260, 70, 0, 0);

  doc.setLineWidth(2.0);
  doc.line(20, 80, 320, 80);
  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  doc.text(`Shipper:`, marginLeft, marginTop + 60, 0, 0);
  doc.text(`Contact:`, 260, marginTop + 60, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `${
      isNull(ShipmentData.sender)
        ? ShipmentData.shipment_senders[0].name
        : ShipmentData.sender.name
    }`,
    marginLeft,
    marginTop + 70,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_senders[0].company}`,
    marginLeft,
    marginTop + 80,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_senders[0].phone}`,
    260,
    marginTop + 70,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_senders[0].address} ${ShipmentData.shipment_senders[0].address_2}`,
    marginLeft,
    marginTop + 90,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_senders[0].postal_code} ${ShipmentData.shipment_senders[0].city}`,
    marginLeft,
    marginTop + 100,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_senders[0].country.name}`,
    marginLeft,
    marginTop + 110,
    0,
    0
  );
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 115, 320, marginTop + 115);
  doc.setFontSize(12);
  doc.setFont(undefined, "bold");
  doc.text(`Receiver:`, marginLeft, marginTop + 130, 0, 0);
  doc.text(`Contact:`, 260, marginTop + 130, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `${
      isNull(ShipmentData.receiver)
        ? ShipmentData.shipment_receivers[0].name
        : ShipmentData.receiver.name
    }`,
    marginLeft,
    marginTop + 140,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_receivers[0].company}`,
    marginLeft,
    marginTop + 150,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_receivers[0].phone}`,
    260,
    marginTop + 140,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_receivers[0].address} ${ShipmentData.shipment_receivers[0].address_2}`,
    marginLeft,
    marginTop + 160,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_receivers[0].postal_code} ${ShipmentData.shipment_receivers[0].city}`,
    marginLeft,
    marginTop + 170,
    0,
    0
  );
  doc.text(
    `${ShipmentData.shipment_receivers[0].country.name}`,
    marginLeft,
    marginTop + 180,
    0,
    0
  );
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 190, 320, marginTop + 190);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `${ShipmentData.shipment_senders[0].country.name}-${ShipmentData.shipment_senders[0].city}  ${ShipmentData.shipment_receivers[0].country.name}-${ShipmentData.shipment_receivers[0].city}`,
    20,
    marginTop + 205,
    0,
    0
  );
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 220, 320, marginTop + 220);
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  // doc.text(`Product Details`, marginLeft, marginTop+235, 0, 0);
  doc.text(`Service`, marginLeft, marginTop + 235, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `${ShipmentData.service_type.name} `,
    marginLeft,
    marginTop + 245,
    0,
    0
  );
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(`Payer Details`, marginLeft, marginTop + 255, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`Duty A/C:`, marginLeft, marginTop + 265, 0, 0);
  doc.text(
    `${ShipmentData.shipment_tax_type.name}`,
    100,
    marginTop + 265,
    0,
    0
  );
  doc.text(`Taxes A/C:`, marginLeft, marginTop + 275, 0, 0);
  doc.text(
    `${ShipmentData.shipment_tax_type.name}`,
    100,
    marginTop + 275,
    0,
    0
  );
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 300, 320, marginTop + 300);
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(`Shipment Details`, marginLeft, marginTop + 315, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `Ref: ${ShipmentData.shipment_ref}`,
    marginLeft,
    marginTop + 325,
    0,
    0
  );
  // doc.text(`Custom Val: ${sumBy(ShipmentData.)}`, marginLeft, marginTop+335, 0, 0);
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 345, 320, marginTop + 345);
  doc.setFontSize(10);
  doc.setFont(undefined, "bold");
  doc.text(`Weight`, marginLeft, marginTop + 360, 0, 0);
  doc.text(
    `${sumBy(ShipmentData.shipment_packages, "chWeight")} Kg`,
    25,
    marginTop + 370,
    0,
    0
  );
  doc.text(`Pieces`, 260, marginTop + 360, 0, 0);
  // doc.text(`${sumBy(ShipmentData.shipment_data,"quantity")}`, 245, marginTop+370, 0, 0);
  doc.text(
    `${ShipmentData.shipment_packages.length}`,
    265,
    marginTop + 370,
    0,
    0
  );
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 380, 320, marginTop + 380);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`Name`, marginLeft, marginTop + 395, 0, 0);
  doc.text(`Signature`, 130, marginTop + 395, 0, 0);
  doc.text(`Date`, 260, marginTop + 395, 0, 0);
  doc.setLineWidth(2.0);
  doc.line(20, marginTop + 430, 320, marginTop + 430);
  const id = ShipmentData.tracking_id.toLocaleString();
  doc.text(`WAYBILL  ${id}`, 110, marginTop + 500, 0, 0);
  jsPDF.API.events.push(["addFonts", callAddFont]);
  const barcodeEncoder = new Code128Generator();
  doc.addFont("code128-normal.ttf", "code128", "normal");
  doc.setFont("code128", "normal");
  // doc.setTextColor(options.textColor || "#000000");
  doc.setFontSize(60);
  doc.text(
    `${barcodeEncoder.encode(ShipmentData.tracking_id)}`, // encode the barcode value
    80,
    marginTop + 490
  );
  doc.setFontSize(10);

  // doc.barcode('test', {
  //   fontSize: 23,
  //   textColor: "#000000",
  //   x: 5.4,
  //   y: 25.5,
  //   textOptions: { align: "center" } // optional text options
  // })
  doc.setProperties({
    title: `WayBill Doc.pdf`,
  });
  doc.output("dataurlnewwindow");
  // doc.save(
  //   `Daily Sale Report .pdf`
  // );
};
export const invoice = (data1) => {
  // return ()=>{
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "potrait"; // portrait or landscape
  const marginLeft = 40;
  const doc = new jsPDF(orientation, unit, size);
  // const title = "WAYBILL DOC";
  doc.setFontSize(20);
  doc.setFont(undefined, "bold");
  doc.text(`${data1.shipment_purpose.purpose} Invoice`, 200, 45, 0, 0);
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  //        x1,  y1, x2,  y2
  // doc.line(40, 70, 110, 70);
  // doc.line(40, 90, 110, 90);
  // doc.line(40, 70, 40, 90);
  // doc.line(110, 70, 110, 90);
  // // doc.line(50, 70, 90, 70);
  const headersShipper = [
    [
      "Shipper",
      // ${isNull(ShipmentData.sender)?ShipmentData.shipment_senders[0].name:ShipmentData.sender.name}
      `${
        isNull(data1.sender)
          ? data1.shipment_senders[0].name
          : data1.sender.name
      }`,
    ],
  ];
  let contentShipper = {
    startY: 70,
    startX: 20,
    head: headersShipper,
    tableWidth: "wrap",
    styles: { fontSize: 8 },
    margin: {
      left: 10,
      // right:1,
      // size:2
    },
    // rowStyles: {
    //   0: {rowHeight: 15}
    // },
    body: [
      ["Company", `${data1.shipment_senders[0].company}`],
      [
        "Address",
        `${data1.shipment_senders[0].address} ${data1.shipment_senders[0].address_2} ${data1.shipment_senders[0].address_3}`,
      ],
      // ["Address 2",`${data1.shipment_senders[0].address_2}`],
      // ["Address 3",`${data1.shipment_senders[0].address_3}`],
      ["Country", `${data1.shipment_senders[0].country.name}`],
      [
        "City",
        `${data1.shipment_senders[0].postal_code} / ${data1.shipment_senders[0].city} / ${data1.shipment_senders[0].state}`,
      ],
      // ["State",`${data1.shipment_senders[0].state}`],
      // ["Postal Code",`${data1.shipment_senders[0].postal_code}`],
      ["CNIC", `${data1.shipment_senders[0].cnic}`],
      ["Email", `${data1.shipment_senders[0].email}`],
      ["Phone No", `${data1.shipment_senders[0].phone}`],
      ["Vat ID/NTN", `${data1.shipment_senders[0].ntn}`],
    ],
    theme: "grid",
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: 200 },
    },
    // height: 'auto',
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.setFontSize(8);
  doc.autoTable(contentShipper);
  const headersDetail = [["Shipment Detail", ``]];
  let contentDetail = {
    startX: 40,
    startY: doc.lastAutoTable.finalY + 5,
    head: headersDetail,
    tableWidth: "wrap",
    styles: { fontSize: 8 },
    margin: {
      left: 10,
      // right:1,
      // size:2
    },
    body: [
      ["WayBill", `${data1.tracking_id}`],
      ["Shipment Reference", `${data1.shipment_ref}`],
      ["Shipment Type", `${data1.shipment_type}`],
      ["Service", `${data1.service_type.name}`],
      // ["Currency Code", `${data1.shipment_data[0].currency.code}`],
      ["Reason For Export", `${data1.shipment_purpose.purpose}`],
      ["Tax Pay", `${data1.shipment_tax_type.name}`],
      // ["Total Invoice Value",`${sumBy(data, "7")}`]
    ],
    theme: "grid",
    columnStyles: {
      0: { cellWidth: 110 },
      1: { cellWidth: 170 },
    },
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.autoTable(contentDetail);
  const headersReceiver = [
    [
      "Receiver",
      `${
        isNull(data1.receiver)
          ? data1.shipment_receivers[0].name
          : data1.receiver.name
      }`,
    ],
  ];
  let contentReceiver = {
    startX: 250,
    startY: 70,
    tableWidth: "wrap",
    styles: { fontSize: 8 },
    margin: {
      left: 305,
      // right:1,
      // size:2
    },
    head: headersReceiver,
    body: [
      ["Company", `${data1.shipment_receivers[0].company}`],
      [
        "Address",
        `${data1.shipment_receivers[0].address} ${data1.shipment_receivers[0].address_2} ${data1.shipment_receivers[0].address_3}`,
      ],
      // ["Address 2",`${data1.shipment_receivers[0].address_2}`],
      // ["Address 3",`${data1.shipment_receivers[0].address_3}`],
      ["Country", `${data1.shipment_receivers[0].country.name}`],
      [
        "City",
        `${data1.shipment_receivers[0].postal_code} / ${data1.shipment_receivers[0].city} / ${data1.shipment_receivers[0].state}`,
      ],
      // ["State",`${data1.shipment_receivers[0].state}`],
      // ["Postal Code",`${data1.shipment_receivers[0].postal_code}`],
      // ["Address",`${data1.shipment_receivers[0].address}`],
      ["Email", `${data1.shipment_receivers[0].email}`],
      ["Phone No", `${data1.shipment_receivers[0].phone}`],
      ["Vat ID", `${data1.shipment_receivers[0].vat}`],
    ],
    theme: "grid",
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: 200 },
    },
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.autoTable(contentReceiver);
  const headersDetail1 = [["Shipment Detail", ``]];
  let contentDetail1 = {
    startX: 40,
    tableWidth: "wrap",
    styles: { fontSize: 8 },
    margin: {
      left: 305,
      // right:1,
      // size:2
    },
    startY: doc.lastAutoTable.finalY + 35,
    head: headersDetail1,
    body: [
      [
        "Financial Instrument",
        `${data1.financial_instruments == true ? "Yes" : "No"}`,
      ],
      [
        "Financial Instrument No",
        `${
          data1.financial_instruments == true
            ? data1.financial_instruments_no
            : "---"
        }`,
      ],
      [
        "Financial Instrument Bank",
        `${
          data1.financial_instruments == true
            ? data1.financial_instruments_bank
            : "---"
        }`,
      ],
      ["Rebate", `${data1.rebate == true ? "Rebate Cliam" : "Non Rebate"}`],
      ["SRO Number", `${data1.rebate == true ? data1.sro_number : "---"}`],
    ],
    theme: "grid",
    columnStyles: {
      0: { cellWidth: 150 },
      1: { cellWidth: 130 },
    },
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.autoTable(contentDetail1);
  doc.setFontSize(12);
  doc.setFont(undefined, "normal");
  const headers = [
    [
      "Sr #",
      "Description",
      // "Weight Per Item",
      "HS Code",
      "Quantity",
      "Unit",
      "Value",
      "Currency",
      // "Made In",
      "SubTotal",
    ],
  ];
  // const pushData=shipment_data.push(["","","","","","","","",`${sumBy()}`])
  const data = data1.shipment_data.map((elt, i) => [
    i + 1,
    elt.desc,
    // elt.weight,
    elt.code,
    elt.quantity,
    elt.uom.uomName,
    elt.value,
    elt.currency.name,
    // elt.country.name,
    elt.quantity * elt.value,
  ]);
  // const totalData=[["","","","","","","",sumBy(data)]]
  let content = {
    startY: doc.lastAutoTable.finalY + 30,
    // tableWidth: 'wrap',
    startX: 40,
    head: headers,
    styles: { fontSize: 8 },
    body: data,
    theme: "grid",
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.autoTable(content);
  doc.text(
    `Total Invoice Value: ${sumBy(data, "7")} ${
      data1.shipment_data[0].currency.code
    }`,
    390,
    doc.lastAutoTable.finalY + 12,
    0,
    0
  );
  const headersPackages = [
    [
      // "Sr #",
      "Package",
      "Length",
      "Width",
      "Heigth",
      "Dimensional Weight",
      "Actual Weight",
      "Chargeable Weight",
    ],
  ];
  // const pushData=shipment_data.push(["","","","","","","","",`${sumBy()}`])
  const dataPackages = data1.shipment_packages.map((elt, i) => [
    elt.name,
    elt.length,
    elt.width,
    elt.height,
    elt.accWeight,
    elt.weight,
    elt.chWeight,
  ]);
  // const totalData=[["","","","","","","",sumBy(data)]]
  let contentPackages = {
    startY: doc.lastAutoTable.finalY + 20,
    // tableWidth: 'wrap',
    startX: 40,
    head: headersPackages,
    styles: { fontSize: 8 },
    body: dataPackages,
    theme: "grid",
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.autoTable(contentPackages);
  doc.text(
    `Total Weight: ${sumBy(dataPackages, "6")} kg`,
    390,
    doc.lastAutoTable.finalY + 12,
    0,
    0
  );
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(`UNDERTAKING`, 250, doc.lastAutoTable.finalY + 15, 0, 0);
  doc.setFontSize(12);
  doc.setFont(undefined, "normal");
  doc.rect(40, doc.lastAutoTable.finalY + 30, 85, 57);
  doc.text("Declartion", 55, doc.lastAutoTable.finalY + 59, 0, 0);
  doc.rect(125, doc.lastAutoTable.finalY + 30, 450, 23);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(
    "May be Opened Officially and Origin and Destination Customs, Documents to be validated for export.",
    130,
    doc.lastAutoTable.finalY + 43,
    0,
    0
  );
  doc.rect(125, doc.lastAutoTable.finalY + 56 - 5, 450, 30);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(
    "I Cartify that the particulars given in this customs declaration are correct and this item does not contains any",
    130,
    doc.lastAutoTable.finalY + 65,
    0,
    0
  );
  doc.text(
    "dangerous articles prohibited by legisation or by postal or customs regulation.",
    130,
    doc.lastAutoTable.finalY + 75,
    0,
    0
  );
  doc.rect(40, doc.lastAutoTable.finalY + 90 - 5, 85, 25);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text("For and behalf of", 42, doc.lastAutoTable.finalY + 102 - 5, 0, 0);
  doc.rect(125, doc.lastAutoTable.finalY + 90 - 5, 450, 25);
  doc.rect(40, doc.lastAutoTable.finalY + 117 - 5, 85, 35);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text("Shipper Consent", 42, doc.lastAutoTable.finalY + 136 - 5, 0, 0);
  doc.rect(125, doc.lastAutoTable.finalY + 117 - 5, 450, 35);
  doc.setFontSize(9);
  doc.setFont(undefined, "normal");
  doc.text(
    "If due to none filling of any required information then in that case if shipment hold or delay in Pakistan or at",
    130,
    doc.lastAutoTable.finalY + 132 - 5,
    0,
    0
  );
  doc.text(
    "any destination we will not be responsible in any way.",
    130,
    doc.lastAutoTable.finalY + 142 - 5,
    0,
    0
  );
  const headersExtra = [["Name", `Signature`]];
  let contentExtra = {
    startX: 40,
    tableWidth: "wrap",
    margin: {
      left: 210,
      // right:1,
      // size:2
    },
    startY: doc.lastAutoTable.finalY + 162 - 8,
    head: headersExtra,
    body: [["", ``]],
    theme: "grid",
    columnStyles: {
      0: { cellWidth: 110 },
      1: { cellWidth: 110 },
    },
    headStyles: {
      fillColor: "#2980ba",
    },
  };
  doc.autoTable(contentExtra);

  doc.setProperties({
    title: `Invoice`,
  });
  doc.output("dataurlnewwindow");
  // doc.save(
  //   `Daily Sale Report .pdf`
  // );
};

export const requestGetShipmentById = () => {
  return {
    type: "REQUEST_GET_SHIPMENT_BY_ID",
  };
};
export const successGetShipmentById = (data) => {
  return {
    type: "SUCCESS_GET_SHIPMENT_BY_ID",
    payload: data,
  };
};
export const errorGetShipmentById = () => {
  return {
    type: "ERROR_GET_SHIPMENT_BY_ID",
  };
};
export const getShipmentById = (id) => {
  return (dispatch) => {
    dispatch(requestGetShipmentById());
    API.get(`/shipment/${id}`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipmentById(getData));
      })
      .catch((error) => {
        dispatch(errorGetShipmentById());
      });
  };
};

export const requestGetShipmentByIdForPdf = () => {
  return {
    type: "REQUEST_GET_SHIPMENT_BY_ID_FOR_PDF",
  };
};
export const successGetShipmentByIdForPdf = (data) => {
  getWayBill(data);
  data.shipment_type === "Package" && invoice(data);
  return {
    type: "SUCCESS_GET_SHIPMENT_BY_ID_FOR_PDF",
    payload: data,
  };
};
export const errorGetShipmentByIdForPdf = () => {
  return {
    type: "ERROR_GET_SHIPMENT_BY_ID_FOR_PDF",
  };
};
export const getShipmentByIdForPdf = (id) => {
  return (dispatch) => {
    dispatch(requestGetShipmentByIdForPdf());
    API.get(`/shipment/${id}`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipmentByIdForPdf(getData.data[0]));
      })
      .catch((error) => {
        dispatch(errorGetShipmentByIdForPdf());
      });
  };
};

export const requestGetShipmentByIdForWayBack = () => {
  return {
    type: "REQUEST_GET_SHIPMENT_BY_ID_FOR_WAYBACK",
  };
};
export const successGetShipmentByIdForWayBack = (data) => {
  getWayBill(data);
  // data.shipment_type==="Package"&&invoice(data)
  return {
    type: "SUCCESS_GET_SHIPMENT_BY_ID_FOR_WAYBACK",
    payload: data,
  };
};
export const errorGetShipmentByIdForWayBack = () => {
  return {
    type: "ERROR_GET_SHIPMENT_BY_ID_FOR_WAYBACK",
  };
};
export const getShipmentByIdForWayBack = (id) => {
  return (dispatch) => {
    dispatch(requestGetShipmentByIdForWayBack());
    API.get(`/shipment/${id}`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipmentByIdForWayBack(getData.data[0]));
      })
      .catch((error) => {
        dispatch(errorGetShipmentByIdForWayBack());
      });
  };
};

export const requestGetShipmentByIdForInvoice = () => {
  return {
    type: "REQUEST_GET_SHIPMENT_BY_ID_FOR_INVOICE",
  };
};
export const successGetShipmentByIdForInvoice = (data) => {
  // getWayBill(data);
  invoice(data);
  return {
    type: "SUCCESS_GET_SHIPMENT_BY_ID_FOR_INVOICE",
    payload: data,
  };
};
export const errorGetShipmentByIdForInvoice = () => {
  return {
    type: "ERROR_GET_SHIPMENT_BY_ID_FOR_INVOICE",
  };
};
export const getShipmentByIdForInvoice = (data) => {
  return (dispatch) => {
    dispatch(successGetShipmentByIdForInvoice(data));
  };
  // return (dispatch) => {
  //   dispatch(requestGetShipmentByIdForInvoice());
  //   API.get(`/shipment/${id}`)
  //     .then((res) => {
  //       let getData = res.data;
  //       dispatch(successGetShipmentByIdForInvoice(getData.data[0]));
  //     })
  //     .catch((error) => {
  //       dispatch(errorGetShipmentByIdForInvoice());
  //     });
  // };
};

export const requestGetShipmentStatus = () => {
  return {
    type: "REQUEST_GET_SHIPMENT_STATUS",
  };
};
export const successGetShipmentStatus = (data) => {
  return {
    type: "SUCCESS_GET_SHIPMENT_STATUS",
    payload: data,
  };
};
export const errorGetShipmentStatus = () => {
  return {
    type: "ERROR_GET_SHIPMENT_STATUS",
  };
};
export const getShipmentStatus = () => {
  return (dispatch) => {
    dispatch(requestGetShipmentStatus());
    API.get(`/shipment/shipment_status`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipmentStatus(getData));
      })
      .catch((error) => {
        dispatch(errorGetShipmentStatus());
      });
  };
};

export const UpdateRequestShipmentStatus = () => {
  return {
    type: "UPDATE_REQUEST_SHIPMENT_STATUS",
  };
};
export const UpdateSuccessShipmentStatus = (data) => {
  return {
    type: "UPDATE_SUCCESS_SHIPMENT_STATUS",
    payload: data,
  };
};

export const UpdateErrorShipmentStatus = () => {
  return {
    type: "UPDATE_ERROR_SHIPMENT_STATUS",
  };
};

export const updateShipmentStatus = (data,EditDate, id) => {
  console.log(data,EditDate, id,"aaaaaaaaaaaaaaaaaaaa")
  return (dispatch) => {
    dispatch(UpdateRequestShipmentStatus());
    API.post(
      `/shipment/shipment_status_update/${id}`,
      {
        // data
        // name: data.name,
        // company: data.companyName,
        // // country_id:data.countryId,
        // address: data.companyAddress,
        // address_2: data.companyAddress2,
        // address_3: data.companyAddress3,
        // postal_code: data.postalCode,
        // city: data.city,
        // state: data.state,
        // email: data.email,
        // phone: data.phone,
        data,
        date:EditDate,
      },
      {}
    )
      .then((res) => {
        dispatch(getShipment());
        dispatch(UpdateSuccessShipmentStatus([data]));
      })
      .catch((error) => dispatch(UpdateErrorShipmentStatus()));
  };
};
export const setEditShipmentData = (data) => {
  return {
    type: "SET_EDIT_SHIPMENT_DATA",
    payload: data,
  };
};
export const setEditShipmentPackData = (data) => {
  return {
    type: "SET_EDIT_SHIPMENT_PACKAGING_DATA",
    payload: data,
  };
};
export const setEditShipmentPackAddData = () => {
  return {
    type: "SET_EDIT_SHIPMENT_PACKAGING_ADD_DATA",
    // payload: data
  };
};
export const setEditShipmentPackRemoveData = (i) => {
  return {
    type: "SET_EDIT_SHIPMENT_PACKAGING_REMOVE_DATA",
    payload: i,
  };
};

export const setEditShipmentDetail = (data) => {
  return {
    type: "SET_EDIT_SHIPMENT_DETAIL",
    payload: data,
  };
};
export const setEditShipmentAddDetail = () => {
  return {
    type: "SET_EDIT_SHIPMENT_ADD_DETAIL",
    // payload: data
  };
};
export const setEditShipmentRemoveDetail = (i) => {
  return {
    type: "SET_EDIT_SHIPMENT_REMOVE_DETAIL",
    payload: i,
  };
};
export const setEditShipmentSender = (data) => {
  return {
    type: "SET_EDIT_SHIPMENT_SENDER",
    payload: data,
  };
};
export const requestGetShipmentByStatusId = () => {
  return {
    type: "REQUEST_GET_SHIPMENT_BY_STATUS_ID",
  };
};
export const successGetShipmentByStatusId = (data) => {
  return {
    type: "SUCCESS_GET_SHIPMENT_BY_STATUS_ID",
    payload: data,
  };
};
export const errorGetShipmentByStatusId = () => {
  return {
    type: "ERROR_GET_SHIPMENT_BY_STATUS_ID",
  };
};
export const getShipmentByStatusId = (id) => {
  return (dispatch) => {
    dispatch(requestGetShipmentByStatusId());
    API.get(`/shipment/get_shipment_with_statusId/${id}`)
      .then((res) => {
        let getData = res.data;
        dispatch(successGetShipmentByStatusId(getData));
      })
      .catch((error) => {
        dispatch(errorGetShipmentByStatusId());
      });
  };
};
export const requestPostVoucher = () => {
  return {
    type: "REQUEST_POST_VOUCHER",
  };
};
export const successPostVoucher = (data) => {
  return {
    type: "SUCCESS_POST_VOUCHER",
    payload: data,
  };
};
export const errorPostVoucher = () => {
  return {
    type: "ERROR_POST_VOUCHER",
  };
};
export const postVoucher = (id, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestPostVoucher());
    API.get(`/shipment/shipment_post_voucher/${id}`)
      .then((res) => {
        let getData = res.data;
        dispatch(successPostVoucher(getData));
        handleVisible(res.data.message);
      })
      .catch((error) => {
        dispatch(errorPostVoucher());
        handleDangerVisible(error.response.data.message);
      });
  };
};
export const resetReducer = () => {
  return {
    type: "RESET_REDUCER",
  };
};

export const setEditStatus = (data) => {
  return {
    type: "SET_EDIT_STATUS",
    payload: data,
  };
};

export const UpdateRequestShipmentAddStatus = () => {
  return {
    type: "UPDATE_REQUEST_SHIPMENT_ADD_STATUS",
  };
};
export const UpdateSuccessShipmentAddStatus = (data) => {
  return {
    type: "UPDATE_SUCCESS_SHIPMENT_ADD_STATUS",
    payload: data,
  };
};

export const UpdateErrorShipmentAddStatus = () => {
  return {
    type: "UPDATE_ERROR_SHIPMENT_ADD_STATUS",
  };
};

export const updateShipmentAddStatus = (data, id) => {
  return (dispatch) => {
    dispatch(UpdateRequestShipmentAddStatus());
    API.post(`/shipment/add_shipment_status/${id}`, {
      data,
    })
      .then((res) => {
        dispatch(getShipment());
        dispatch(UpdateSuccessShipmentAddStatus([data]));
      })
      .catch((error) => dispatch(UpdateErrorShipmentAddStatus()));
  };
};
